import { render, staticRenderFns } from "./cloneTab.vue?vue&type=template&id=7ec79238&"
import script from "./cloneTab.vue?vue&type=script&lang=js&"
export * from "./cloneTab.vue?vue&type=script&lang=js&"
import style0 from "./cloneTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports